import { schema } from 'normalizr';

export const sectorSchema = new schema.Entity('sectors', {}, { idAttribute: '_id' });
export const sectorListSchema = [sectorSchema];
